import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { textAPI } from 'api';
import { Path } from 'routes';
import { getSafeString } from 'utils/getSafeString';
import { useApp } from 'context/AppContext';
import { ReactComponent as IconLogo } from 'logo.svg';
import { ReactComponent as IconLogoBrand } from 'logo-brand.svg';
import { ReactComponent as IconMenu } from 'assets/icons/header-menu.svg';
import { ReactComponent as IconBack } from 'assets/icons/header-back.svg';
import { useTranslation } from 'react-i18next';
import {
    Component, Logo, Nav, Menu, MainContent, SupportContacts,
} from './Header.styled';

export const Header = () => {
    const { title, menu } = useApp();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const { data } = textAPI.useGetSupportQuery();

    const goBack = () => {
        navigate(-1);
    };

    if (pathname === Path.private.registration) return null;
    // That's temporary decision for keeping default header place, cause if it isn't markup is going to be broken
    if (pathname.includes('chat')) return <Component />;

    return (
        <Component>
            <SupportContacts dangerouslySetInnerHTML={{ __html: getSafeString(data?.content) }} />
            <MainContent>
                { pathname === Path.public.main
                    ? (
                        <Logo>
                            <Link to={Path.public.main}>
                                <IconLogo />
                                <IconLogoBrand />
                            </Link>
                        </Logo>
                    )
                    : (
                        <Nav onClick={goBack}>
                            <IconBack />
                            <h1>{ pathname.includes('user') ? t('title.header_back_to_chat') : title }</h1>
                        </Nav>
                    )}
                <Menu isActiveMenu={menu.active}>
                    <span>18+</span>
                    <button name="menu" onClick={menu.toggle} type="button">
                        <IconMenu />
                    </button>
                </Menu>
            </MainContent>
        </Component>
    );
};
